import { createFormatter } from '@cof/fs-currency-field-core-beta';
/** Validates the currency input against the field's maximum allowable value */
export const maxValidatorCurrency = {
    attribute: 'max',
    key: 'rangeOverflow',
    message(instance) {
        const format = createFormatter(instance.managerConfig);
        return `Please enter a value less than the maximum of ${format(instance.max.toString())}`;
    },
    isValid(instance) {
        /** If max is undefined or the manager is not yet created, the field is valid */
        if (instance.max === undefined || isNaN(+instance.max) || !instance.manager) {
            return true;
        }
        return +instance.unmaskedValue <= instance.max;
    }
};
/** Validates the currency input against the field's minimum allowable value */
export const minValidatorCurrency = {
    attribute: 'min',
    key: 'rangeUnderflow',
    message(instance) {
        const format = createFormatter(instance.managerConfig);
        return `Please enter a value greater than the minimum of ${format(instance.min.toString())}`;
    },
    isValid(instance) {
        /** If min is undefined or the manager is not yet created, the field is valid */
        if (instance.min === undefined || isNaN(+instance.min) || !instance.manager) {
            return true;
        }
        return +instance.unmaskedValue >= instance.min;
    }
};
//# sourceMappingURL=currency-validators.js.map